import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import SectionTitle from '../layout/SectionTitle';
import { useInView } from 'react-intersection-observer';

const Historique = () => {
  const { t } = useTranslation();
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1
  });
  
  // Données de la timeline avec clés de traduction
  const timelineData = [
    { 
      year: t('about.history.event1.year'), 
      title: t('about.history.event1.title'), 
      description: t('about.history.event1.description'),
      image: '/images/timeline1.jpg'
    },
    { 
      year: t('about.history.event2.year'), 
      title: t('about.history.event2.title'), 
      description: t('about.history.event2.description'),
      image: '/images/timeline2.png'
    },
    { 
      year: t('about.history.event3.year'), 
      title: t('about.history.event3.title'), 
      description: t('about.history.event3.description'),
      image: '/images/timeline3.jpg'
    },
    { 
      year: t('about.history.event4.year'), 
      title: t('about.history.event4.title'), 
      description: t('about.history.event4.description'),
      image: '/images/timeline4.jpg'
    },
    { 
      year: t('about.history.event5.year'), 
      title: t('about.history.event5.title'), 
      description: t('about.history.event5.description'),
      image: '/images/timeline5.jpg'
    },
    { 

      year: t('about.history.event6.year'), 
      title: t('about.history.event6.title'), 
      description: t('about.history.event6.description'),
      image: '/images/timeline6.jpg'
    },
    { 
      year: t('about.history.event7.year'), 
      title: t('about.history.event7.title'), 
      description: t('about.history.event7.description'),
      image: '/images/timeline7.png'
    },
    { 
      year: t('about.history.event8.year'), 
      title: t('about.history.event8.title'), 
      description: t('about.history.event8.description'),
      image: '/images/timeline8.png'
    },
  ];
  
  return (
    <section className="py-8 bg-white" ref={ref}>
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="mt-0"
        >
          <SectionTitle 
            overline={t('about.history.title')}
            highlight={t('about.history.highlight')}
            separatorColor="socabeg-blue"
            showLogo={true}
          />
        </motion.div>
        
        <div className="mt-8 relative">
          {/* Ligne verticale centrale */}
          <div className="absolute left-1/2 transform -translate-x-1/2 h-full w-1 bg-socabeg-blue"></div>
          
          {/* Événements de la timeline */}
          <div className="relative">
            {timelineData.map((item, index) => {
              const isEven = index % 2 === 0;
              const delay = 0.2 + index * 0.1;
              
              return (
                <motion.div 
                  key={index} 
                  className={`flex items-center mb-12 ${isEven ? 'flex-row' : 'flex-row-reverse'}`}
                  initial={{ opacity: 0, x: isEven ? -50 : 50 }}
                  animate={inView ? { opacity: 1, x: 0 } : {}}
                  transition={{ duration: 0.6, delay }}
                >
                  {/* Contenu */}
                  <div className={`w-5/12 ${isEven ? 'text-right pr-8' : 'text-left pl-8'}`}>
                    <h3 className="text-xl font-bold text-socabeg-blue mb-2">{item.year}</h3>
                    <h4 className="text-lg font-semibold mb-2">{item.title}</h4>
                    <p className="text-gray-600">{item.description}</p>
                  </div>
                  
                  {/* Point central */}
                  <div className="w-2/12 flex justify-center relative">
                    <div className="w-6 h-6 bg-white border-4 border-socabeg-blue rounded-full z-10"></div>
                  </div>
                  
                  {/* Image associée à l'événement (sans card autour) */}
                  <div className="w-5/12 px-4 flex justify-center">
                    {item.image && (
                      <img 
                        src={item.image} 
                        alt={item.title} 
                        className={`max-w-full h-auto max-h-[150px] sm:max-h-[200px] md:max-h-[250px] lg:max-h-[300px] object-contain ${index === 3 ? 'xl:max-h-[350px]' : ''}`}
                      />
                    )}
                  </div>
                </motion.div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Historique;
